import React, { useState, useEffect } from 'react';
import './ChartPanel.css';
import { BASE_URL } from '../../../config';
import ChartSidebar from './ChartSidebar';

const LAYER_LABEL_OVERRIDES = {
    trafo_stanice: 'Trafostanice',
    trafo_stanica: 'Trafostanica',

    mjerna_mjesta: 'Mjerna mjesta',
    mjerno_mjesto: 'Mjerno mjesto',

    ocitacki_hod: 'Očitački hod',
    ocitacki_hodovi: 'Očitački hodovi',

    stubovi: 'Stubovi',
    stub: 'Stub',

    vod: 'Dalekovodi',
    vodovi: 'Dalekovodi',
    dalekovod: 'Dalekovod',
    dalekovodi: 'Dalekovodi',
};

const toTitleCase = (text = '') =>
    text
        .toLowerCase()
        .split(' ')
        .filter(Boolean)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');

const cleanLayerName = (id = '') => {
    const rawName = id
        .replace(/-layer$/i, '')
        .replace(/^wfs[-_:]/i, '')
        .replace(/^pgsql[-_:]/i, '')
        .replace(/^elektro:/i, '')
        .replace(/^GeoSolution:/i, '')
        .trim();

    const normalizedKey = rawName
        .replace(/-/g, '_')
        .replace(/\s+/g, '_')
        .toLowerCase();

    if (LAYER_LABEL_OVERRIDES[normalizedKey]) {
        return LAYER_LABEL_OVERRIDES[normalizedKey];
    }

    return toTitleCase(rawName.replace(/_/g, ' '));
};

const getLayerLabel = (layer) =>
    layer?.props?.displayName ||
    layer?.props?.name ||
    layer?.props?.title ||
    layer?.props?.layerName ||
    cleanLayerName(layer?.id);

const ChartPanel = ({ wfsLayers }) => {
    const [isChartOpen, setIsChartOpen] = useState(false);
    const [filteredWfsLayers, setFilteredWfsLayers] = useState([]);
    const [url, setUrl] = useState(null);
    const [activeLayerId, setActiveLayerId] = useState(null);

    useEffect(() => {
        const filtered = (wfsLayers || []).filter(
            layer => layer.props?.source === 'internal'
        );

        const prevIds = filteredWfsLayers.map(layer => layer.id).sort().join(',');
        const newIds = filtered.map(layer => layer.id).sort().join(',');

        if (prevIds !== newIds) {
            setFilteredWfsLayers(filtered);
        }
    }, [wfsLayers, filteredWfsLayers]);

    const generateUrl = (layer) => {
        const layerId = layer.id;

        const layerName = layerId.includes('-')
            ? layerId.substring(0, layerId.indexOf('-'))
            : layerId;

        const nextUrl = `${BASE_URL}/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=${layerName}&outputFormat=application/json`;

        setUrl(nextUrl);
        setActiveLayerId(layerId);
        setIsChartOpen(true);
    };

    return (
        <div className="chart-panel">
            {filteredWfsLayers.length === 0 ? (
                <p className="no-layer-msg">Nema dodatih WFS slojeva.</p>
            ) : (
                <>
                    <h5>Izaberite sloj</h5>

                    <div className="layer-chart-label-div">
                        {filteredWfsLayers.map(layer => (
                            <button
                                key={layer.id}
                                type="button"
                                className={`chart-panel-button ${
                                    activeLayerId === layer.id ? 'active' : ''
                                }`}
                                onClick={() => generateUrl(layer)}
                            >
                                {getLayerLabel(layer)}
                            </button>
                        ))}
                    </div>
                </>
            )}

            <ChartSidebar
                isOpen={isChartOpen}
                setIsChartOpen={setIsChartOpen}
                inputUrl={url}
            />
        </div>
    );
};

export default ChartPanel;